<app-confirm-action-modal
  testId="archive-campaign-dialog"
  title="Archive Campaign?"
  confirmLabel="Yes, Archive"
  (confirm)="onConfirmArchive()"
  (cancel)="onClose()"
>
  <div class="message-content">
    <p>Archiving will stop this campaign and make it unavailable for future campaigns</p>
    <p>Are you sure you want to continue?</p>
  </div>
</app-confirm-action-modal>
